module.exports = __webpack_public_path__ + "img/b2.a2628caa.png";